export const DIALOGIFRAME_OPEN='DIALOGIFRAME_OPEN';
export const DIALOGIFRAME_CLOSE='DIALOGIFRAME_CLOSE';


// WEBPACK FOOTER //
// ./src/redux/dialogIframe/actionTypes.js